import {inject} from "@angular/core";
import {CanActivateFn, Router} from '@angular/router';
import {AuthStore} from "@app/authentication";
import {ToastrService} from 'ngx-toastr';

/**
 * Guard pour gérer la déconnexion et l'expiration des sessions
 */
export const LogoutGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  try {
    // Vérifier si l'utilisateur est déjà authentifié
    if (authStore.isAuthenticated()) {
      // Si token valide et route auth, rediriger vers la page d'accueil
      if (state.url.includes('/authentication')) {
        toastr.info('Vous êtes déjà connecté');
        router.navigate(['/muslim-market']);
        return false;
      }
    }

    return true;

  } catch (error) {
    console.error('Erreur dans LogoutGuard:', error);
    return true;
  }
};

/**
 * Guard pour les routes nécessitant d'être déconnecté
 */
export const RequireLoggedOutGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  if (authStore.isAuthenticated()) {
    toastr.info('Vous êtes déjà connecté');
    router.navigate(['/muslim-market']);
    return false;
  }

  return true;
};
